import { useGetActiveLeadSource } from '@forwardflow/features/campaign'
import CampaignService from '@forwardflow/services/CampaignService'
import { useApplyPendingModalStore } from '@forwardflow/store/modal/ApplyPendingModal'
import { Button } from '@forwardflow/ui'
import { message, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
const formatSectionName = (section: string): string => {
   return section
      ?.split('_')
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      ?.join(' ')
}
export const ApplyPendingChangesModal = () => {
   const [isLoading, setIsLoading] = useState(false)

   const {
      isApplyPendingModalOpen,
      closeApplyPendingModal,
      getCampaignName,
      getCampaignId,
   } = useApplyPendingModalStore()
   const campaignName = getCampaignName()
   const campaignId = getCampaignId()

   const { data: leadDetails, mutate } = useGetActiveLeadSource(
      campaignId || ''
   )
   useEffect(() => {
      mutate()
   }, [campaignId, mutate])

   const changedSections = Array.isArray(leadDetails?.draft?.changedSections)
      ? leadDetails?.draft?.changedSections
      : []

   const formattedSections =
      changedSections.length > 0
         ? changedSections
              .map((section) => formatSectionName(section))
              .join(', ')
         : 'No changes detected'
   const onActivateCampaign = async () => {
      setIsLoading(true)
      try {
         await CampaignService.activateCampaign(campaignId as string)
         mutate()
         closeApplyPendingModal()
         message.success('Campaign activated successfully')
      } catch (error) {
         console.log('error', error)
         message.error(
            'Error activating campaign: Missing required data for activation'
         )
      } finally {
         setIsLoading(false)
      }
   }
   const navigate = useNavigate()
   const navigateToActivateCampaign = () => {
      navigate(
         `/campaign/${encodeURIComponent(
            campaignId as string
         )}/phone-number?campaignName=${campaignName}`,
         {
            state: { campaignId },
         }
      )
   }
   const onReviewModify = () => {
      navigateToActivateCampaign()
      closeApplyPendingModal()
   }

   return (
      <>
         <Modal
            className="p-0 ff-modal"
            title=""
            open={isApplyPendingModalOpen}
            onCancel={closeApplyPendingModal}
            footer={null}
         >
            <div className="flex items-center justify-between py-3 mb-5 px-11">
               <p className="text-[20px] font-medium pt-3">
                  Apply Pending Changes
               </p>
            </div>
            <div className="pb-8 px-11">
               <div className="px-5 py-4 mb-10 rounded bg-primary/20">
                  <p className="mb-2 font-medium text-[12px]">
                     Draft contains added/edited:
                  </p>
                  <p className="text-sm font-medium">{formattedSections}</p>
               </div>
               <Button
                  isLoading={isLoading}
                  onClick={onActivateCampaign}
                  className="w-full !rounded"
               >
                  Apply Changes
               </Button>
               <Button
                  onClick={onReviewModify}
                  className="w-full !rounded !bg-[#303137] hover:!bg-[#303137]/60 !border-[#303137] hover:!border-[#303137]"
               >
                  Review & Modify
               </Button>

               {/* <Button className="w-full !rounded !bg-[#000]/10 hover:!bg-[#000]/30 border-[#303137] hover:!border-[#303137]">
                  Discard & Start Fresh
               </Button> */}
            </div>
         </Modal>
      </>
   )
}
